angular.module('impactx.budget').controller('BudgetTemplateListCtrl', [
    'selectedListItems',
    BudgetTemplateListCtrl
]);

function BudgetTemplateListCtrl(selectedListItems) {
    var buttonDefinition = [
        {
            label: "details",
            linkFunction: getBudgetLink,
            type: 'link',
            condition: selectedListItems.isSingleSelection,
            process: 'EditBudgetTemplate'
        },
        {
            label: "usage",
            linkFunction: getBudgetTemplateLink,
            type: 'link',
            condition: selectedListItems.isSingleSelection,
            process: 'ListBudgetTemplate'
        }
    ];

    this.meta = {
        buttonDefinition: buttonDefinition,
        rowTemplate: 'modules/budget/templates/btplist.row.tmpl.html',
        isSelectAble: true,
        ctrl: this,
        endpoint: '/budgetTemplate/list',
        id: "budgettemplatelist",
        mainAction: {id: "new", link: "#/budgettemplate/0", icon: "mdi-plus"},
        excelExport: true
    };

    this.getMeta = function () {
        return this.meta;
    };

    function getBudgetLink() {
        return "budgettemplate/" + selectedListItems.getFirstSelectedId();
    }

    function getBudgetTemplateLink() {
        return "budgettemplateusagelist/" + selectedListItems.getFirstSelectedId();
    }
}